import { Component, Input } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { APIService } from 'api/module'
import { NotifyService } from 'common/util/services/notify.service'
import { GenerateProxiesRequest, MediaRootDetail, ProxyProfile } from 'elements-sdk'

@Component({
  selector: 'regenerate-proxies-options',
  templateUrl: './regenerateProxiesOptions.component.pug',
})
export class RegenerateProxiesOptionsComponent {
  @Input() options: GenerateProxiesRequest
  @Input() root?: MediaRootDetail
  @Input() type?: string
  profiles?: ProxyProfile[]

  constructor (
    private api: APIService,
    private translate: TranslateService,
    private notify: NotifyService,
  ) { }

  async ngOnInit () {
    this.profiles = await this.api.mediaLibrary.getAllProxyProfiles({})
    if (this.type) {
      this.profiles = this.profiles.filter(x => x.type === this.type)
    }
    if (this.root) {
      this.options.proxyProfiles = this.profiles.filter(x => this.root?.proxyProfiles?.includes(x.id)).map(x => x.id)
    }
  }

  onUpdate () {
    this.options.retryFailed ||= this.options.force
  }

  toggleProfile (profile) {
    if (this.options.proxyProfiles.includes(profile.id)) {
      this.options.proxyProfiles = this.options.proxyProfiles.filter(x => x !== profile.id)
    } else {
      this.options.proxyProfiles.push(profile.id)
    }
  }
}
